/* Power House — fermeture de l'accordéon variant-picker mobile */
(() => {
  const SELECTOR = 'details.variant-picker__mobile';

  // Clic en dehors → ferme tous les accordéons ouverts
  document.addEventListener('click', (e) => {
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // Sélection d'une variante → ferme l'accordéon parent
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[type="radio"]')) {
      e.target.closest(SELECTOR)?.removeAttribute('open');
    }
  });

  // Touche Échap → ferme les accordéons ouverts (et rend le focus au summary si nécessaire)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((d) => {
      const focusWasInside = d.contains(document.activeElement);
      d.removeAttribute('open');
      if (focusWasInside) d.querySelector('summary')?.focus();
    });
  });
})();

/* Power House — Déplace la galerie photo sur mobile (< 1000px) pour qu'elle
   se positionne juste avant le bloc sélecteur de variantes, style Gorilla Mind.
   Reste DANS <product-rerender> pour préserver le re-render image sur changement
   de variante. Restauration à la position d'origine au-dessus de 1000px. */
(() => {
  const productRerender = document.querySelector('product-rerender');
  if (!productRerender) return;

  // Garde : on agit uniquement sur la page produit principale (celle qui a une galerie
  // ET un variant-picker block). Le sticky bar et le quick-buy n'ont pas les deux.
  if (!productRerender.querySelector('product-gallery') ||
      !productRerender.querySelector('.product-info__variant-picker')) {
    return;
  }

  const productRerenderParent = productRerender.parentElement;
  const DESKTOP_QUERY = window.matchMedia('(min-width: 1000px)');
  const DEBUG = true; // À passer à false après validation visuelle

  const log = (...args) => DEBUG && console.log('[PH gallery reorder]', ...args);

  let rafId = null;

  const reorganize = () => {
    rafId = null;

    // Re-query à chaque exécution : le DOM peut avoir été remplacé par un re-render
    const rerender = document.querySelector('product-rerender');
    if (!rerender) return;

    const gallery = rerender.querySelector('product-gallery');
    const product = rerender.querySelector('.product');
    const productInfo = rerender.querySelector('.product-info');
    const variantPickerBlock = rerender.querySelector('.product-info__block-item[data-block-type="variant-picker"]');

    if (!gallery || !product || !productInfo) {
      log('aborted: missing element(s)', { gallery: !!gallery, product: !!product, productInfo: !!productInfo });
      return;
    }

    const isMobile = !DESKTOP_QUERY.matches;

    if (isMobile) {
      if (!variantPickerBlock) {
        log('mobile: no variant-picker block (merchant disabled it?), skipping');
        return;
      }
      // Idempotence : déjà sibling juste avant variant-picker → no-op
      if (gallery.parentElement === productInfo && gallery.nextElementSibling === variantPickerBlock) {
        return;
      }
      productInfo.insertBefore(gallery, variantPickerBlock);
      log('mobile: gallery moved inside .product-info, before variant-picker block');
    } else {
      // Idempotence : déjà à la position d'origine (premier enfant de .product, avant .product-info)
      if (gallery.parentElement === product && gallery.nextElementSibling === productInfo) {
        return;
      }
      product.insertBefore(gallery, productInfo);
      log('desktop: gallery restored to original position (before .product-info)');
    }
  };

  const schedule = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(reorganize);
  };

  // 1. Application initiale (defer → DOM déjà parsé à ce point)
  schedule();

  // 2. Bascule mobile ↔ desktop sur resize
  DESKTOP_QUERY.addEventListener('change', () => {
    log('viewport breakpoint crossed (1000px)');
    schedule();
  });

  // 3. Re-render produit (full ou partial) → observer sur le PARENT de product-rerender
  //    car en cas de full re-render, product-rerender lui-même est remplacé via replaceWith.
  //    L'observation du parent catche les deux cas.
  const observer = new MutationObserver(() => schedule());
  observer.observe(productRerenderParent, { childList: true, subtree: true });

  log('initialized');
})();
